
export default {
  layout:'default',
   async asyncData({ $axios }) {
    const indexGoodsRankLists = await $axios.get("/uk-api/home/indexGoodsRankList");
    return {
      indexGoodsRankLists: indexGoodsRankLists.result,
    };
  },
  data() {
    return {
      
    };
  },
  methods:{
    
  },
};
